// Utility to convert HEIC/HEIF files to JPEG in the browser
// Uses dynamic import of heic2any to keep bundle size low.

export async function convertHeicFilesToJpeg(
  files: FileList
): Promise<FileList> {
  const dt = new DataTransfer();

  // Lazy-load converter only if needed
  let heic2any: null | ((opts: any) => Promise<Blob | Blob[]>) = null;

  const isHeicLike = (file: File) => {
    const type = file.type?.toLowerCase();
    const name = file.name?.toLowerCase();
    return (
      type === 'image/heic' ||
      type === 'image/heif' ||
      name.endsWith('.heic') ||
      name.endsWith('.heif')
    );
  };

  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    if (!isHeicLike(file)) {
      dt.items.add(file);
      continue;
    }

    try {
      if (!heic2any) {
        // Dynamic import; types are not provided by default
        // @ts-ignore
        const mod = await import('heic2any');
        heic2any = (mod.default || mod) as any;
      }

      const result = await heic2any!({
        blob: file,
        toType: 'image/jpeg',
        quality: 0.9
      });

      const blob = Array.isArray(result) ? result[0] : result;
      const newName = file.name.replace(/\.(heic|heif)$/i, '.jpg');
      const jpegFile = new File([blob], newName, { type: 'image/jpeg' });
      dt.items.add(jpegFile);
    } catch (e) {
      console.warn('HEIC conversion failed; keeping original file.', e);
      dt.items.add(file);
    }
  }

  return dt.files;
}
